import sanitizeHtml from 'sanitize-html';
import { defineNuxtPlugin } from '~/.nuxt/imports';

const { defaults } = sanitizeHtml;
const options = {
  ...defaults,
  allowedTags: [...defaults.allowedTags, 'img'],
  allowedAttributes: {
    ...defaults.allowedAttributes,
    img: ['src', 'height', 'width'],
    span: ['style', 'class']
  },
  allowedSchemesByTag: { img: ['data'] },
  allowedClasses: {
    span: ['ql-size-small', 'ql-size-large', 'ql-size-huge', 'ql-syntax']
  },
  allowedStyles: {
    span: {
      color: [/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/]
    }
  }
};

export default defineNuxtPlugin(({ provide }) => {
  provide('sanitize', (dirty, opts = null) =>
    sanitizeHtml(dirty, opts || options)
  );
});
